// nigeriaStates.js
const nigeriaStates = [
    'Abia',
    'Adamawa',
    'Anambra',
    'Bauchi',
    'Benue',
    'Delta',
    'Edo',
    'Enugu',
    'Abuja',
    'Gombe',
    'Imo',
    'Jigawa',
    'Kaduna',
    'Kano',
    'Katsina',
    'Kebbi',
    'Kogi',
    'Kwara',
    'Lagos',
    'Nasarawa',
    'Ogun',
    'Ondo',
    'Osun',
    'Oyo',
    'Sokoto',
    'Zamfara',
  ];
  
  export default nigeriaStates;
  